module.exports = __webpack_public_path__ + "static/media/eduardo-rodrigues.4ac0365d.png";